module.exports = __webpack_public_path__ + "static/media/logo-td-bank.5496f9ab.svg";